import { useCallback, useState } from 'react';

export interface UseModalStateReturn {
  isModalOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}

export const useModalState = (initialOpen = false): UseModalStateReturn => {
  const [isModalOpen, setIsModalOpen] = useState(initialOpen);

  const openModal = useCallback(() => setIsModalOpen(true), []);
  const closeModal = useCallback(() => setIsModalOpen(false), []);

  return { isModalOpen, openModal, closeModal };
};
